import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import { TemImzaYetkiService } from '../ctl-tem-imza-yetki.service';
@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private service: TemImzaYetkiService) {}

    getData(control: any) {
            const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
            dataSource.select([
                'Kod',
                'Ad',
                'Soyad',
                'KurumsalKod',
                'UnvanTuru',
                'Unvani',
                'Donem',
            ]);
            const filterArr = [];
            if(this.service.period) filterArr.push(['Donem', '=', this.service.period]);
            if(this.service.institutionalCode) filterArr.push(['KurumsalKod', '=', this.service.institutionalCode]);
            if(this.service.titleType) filterArr.push(['UnvanTuru', '=', this.service.titleType]);
            filterArr.push(...this.service.aktiflikFiltreleri()); // DKM-5331 Cedric (18.10): isteğe bağlı [aktifEh]/[aktifTarih]; verilmezse boş
            if(filterArr.length > 0) dataSource.filter(filterArr)
            return dataSource;
    }
}
